import { InputField } from 'components/molecules'

const MarketingDiscountBatchItemSkuField = () => (
  <InputField
    name='sku'
    label='SKU'
    placeholder='SKU'
    type='text'
  />
)

export default MarketingDiscountBatchItemSkuField
